<template>
  <v-list-cell size="1" class="thumbnail">
    <div slot="value" class="w-full flex justify-center relative">
      <div v-if="currentContact.image && !isReady" class="w-full flex justify-center relative">
        <v-spinner slot="value" size="10" style="width: auto; background: transparent" :loading="true"></v-spinner>
      </div>
      <v-lazy-load v-if="isReady" :image="imageUrl" placeholderFileName="folderClient"></v-lazy-load>
    </div>
  </v-list-cell>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ContactListImage",
  props: {
    currentContact: {
      type: Object,
      default: function () {
        return {};
      },
    },
    currentProfileImage: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      amountTry: 10,
      timeWaitStart: 3000,
      timer: null,
      imageUrl: "",
      item: {},
    };
  },
  created() {
    this.item = this.currentProfileImage;
    this.untilReady();
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    ...mapActions(["getContact", "getContactImagePreview"]),
    getItemPreview() {
      const vm = this;
      if (vm.isConverted) {
        vm.getContactImagePreview({
          customLoading: true,
          file: vm.currentContact.image.uid,
          contact: vm.currentContact.uid,
          width: "100",
          height: "100",
        })
          .then((res) => {
            vm.imageUrl = res;
          })
          .catch(() => {});
      } else {
        vm.imageUrl = "";
      }
    },
    untilReady() {
      if (this.item) {
        this.getItemPreview();
        const data = {
          contact: this.currentContact.uid,
        };
        if (!this.isReady) {
          const vm = this;
          vm.timer = setTimeout(function () {
            vm.getContact(data)
              .then((response) => {
                vm.item = response.image;
                vm.amountTry = vm.amountTry - 1;
                if (vm.amountTry <= 0) {
                  vm.amountTry = 10;
                  vm.timeWaitStart = vm.timeWaitStart + 60000;
                }
                vm.untilReady();
              })
              .catch();
          }, vm.timeWaitStart);
        }
      }
    },
    isConvertedCalculate(item) {
      return this.statiBits && item ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (this.statiBits && item) {
        return (
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
        );
      } else {
        return false;
      }
    },
    isDownloadableCalculate(item) {
      return this.statiBits && item
        ? this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_OK.bit) ||
            this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_NA.bit)
        : false;
    },
  },
  computed: {
    isConverted() {
      return this.isConvertedCalculate(this.item);
    },
    isReady() {
      return this.isReadyCalculate(this.item);
    },
    isDisabled() {
      return !this.isDownloadable;
    },
    isDownloadable() {
      return this.isDownloadableCalculate(this.item);
    },
    currentStatus() {
      return this.statiBits && this.item ? this.$h.globalGetCurrentFileStatus(this.item.status, this.statiBits) : "";
    },
    ...mapGetters({
      statiBits: "global_get_fileStatiBits",
    }),
  },
};
</script>
